import { GuidService } from 'ui-components/services/guid-service';
import * as BulkUpdateActions from '../../../store/bulk/update/bulk.update.actions';
import { BulkActions } from '../../../enums/bulk-actions';

export const PackageBulkAction = {
  id: 'package',
  name: BulkActions.packageBulkAction.message,

  makeHandler: (dispatch, bulkUpdateTypeData) => {
    return (ids, filters) =>
      dispatch(
        BulkUpdateActions.startBulkUpdateJob(bulkUpdateTypeData, [BulkActions.packageBulkAction], ids, GuidService.newGuid(), filters),
      );
  },
};
